var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Colour",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 16.6666V13.8892L11.5247 5.69774L14.3021 8.47513L6.11064 16.6666H3.33325ZM16.4499 5.28298C16.7388 5.57183 16.7388 6.03843 16.4499 6.32728L15.0946 7.68265L12.3172 4.90526L13.6726 3.54989C13.9614 3.26104 14.428 3.26104 14.7169 3.54989L16.4499 5.28298Z",
    fill: "#3A4861"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.7824e561ca58c0d95b2b3ab897f3d834.svg";
export { ForwardRef as ReactComponent };